import React from 'react';
import PropTypes from 'prop-types';
import { MyOutsourcesManagerDashboard } from './MyOutsourcesManagerDashboard';
import { MyContractorsManagerDashboard } from './MyContractorsManagerDashboard';
import { OutsourceBanner } from '../banner/OutsourceBanner';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';

export class AdminDashboard extends React.Component {

    render() {
        const {
            currentUser,
            outsource,
            breadcrumbs,
        } = this.props;

        if ( currentUser.homeScreen() === PsCompanyManagement.MY_OUTSOURCES ) {
            return (
                <MyOutsourcesManagerDashboard breadcrumbs={breadcrumbs}/>
            );
        }

        return (
            <MyContractorsManagerDashboard breadcrumbs={breadcrumbs}>
                <OutsourceBanner outsource={outsource} />
            </MyContractorsManagerDashboard>
        );
    }
}

AdminDashboard.propTypes = {
    outsource: PropTypes.any,
    currentUser: PropTypes.any,
};

AdminDashboard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboards/AdminDashboard.jsx